<template>
  <el-dialog :title="dialogTitle" :visible.sync="open" :center="true" width="90%" @close="cancel" :close-on-click-modal="false" :close-on-press-escape="false">

    <el-form>
      <div style="margin: 9px 257px;  margin-bottom: -33px">
        <span> 发票金额:{{this.returnInvoiceAmount}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span> 发票号码:{{this.returnInvoiceCode}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span> 已选金额:<span class=" font">{{this.selectedTotalAmount}}&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
        <span> 已选数量:<span class="font">{{this.selectedTotalNumber}}&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
      </div>
      <template>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="待选择单据" name="first">
            <el-row style="margin-top: 6px">
              <template v-for="(item, index) in filterOptions">
                <el-col v-if="!item.hidden" :key="index" :span="item.type == 'date' ? 6 : 4">
                  <el-form-item :prop="item.code">
                    <el-date-picker v-if="item.type == 'date'" :clearable="false" v-model="query[item.code]" style="width:100%" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @input="val => dateChange(val, item)" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>

                    <el-input v-if="item.type == 'input'" :ref="item.code" v-model="query[item.code]" style="width:100%" :placeholder="'请填写' + item.name" @keydown.enter.native="queryChange"></el-input>
                    <el-select v-if="item.type == 'select' && !item.multiple&&item.code=='patientId'" v-model="query[item.code + 'Name']" style="width:100%" :placeholder="'请选择' + item.name" clearable filterable :filter-method="
                    (k) => selectFilterChange(item.filterMethod ? item.filterMethod : null, k, item)" @change="val => selectChange(val, item)">
                    <el-option v-for="m in item.data" :key="m.id" :label="(item.no ? m[item.no] : m.no)+' '+(item.labelName ? m[item.labelName] : m.name)" :value="m.parentId"></el-option>
                      </el-select>

                    <el-select v-else-if="item.type == 'select' && !item.multiple" v-model="query[item.code + 'Name']" style="width:100%" :placeholder="'请选择' + item.name" clearable filterable :filter-method="
                  (k) => selectFilterChange(item.filterMethod ? item.filterMethod : null, k, item)" @change="val => selectChange(val, item)">
                      <el-option v-for="m in item.data" :key="m.id" :label="((item.no ? m[item.no] : m.no)??'')+' '+(item.labelName ? m[item.labelName] : m.name)" :value="m.id"></el-option>
                    </el-select>

                    <el-select v-if="item.type == 'select' && item.multiple" v-model="query[item.code]" style="width:100%" :multiple="item.multiple" :placeholder="'请选择' + item.name" clearable filterable :filter-method="
                  (k) => selectFilterChange(item.filterMethod ? item.filterMethod : null, k, item)" @change="val => selectMultipleChange(val, item)">
                      <el-option v-for="m in item.data" :key="m.id" :label="item.labelName ? m[item.labelName] : m.name" :value="m.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </template>
              <el-col :span="20">
                <el-button class="btn primary" size="small" v-preventReClick @click="queryChange">查询</el-button>
                <el-button class="btn default" size="small" v-preventReClick @click="reset">重置</el-button>
                <el-button class="btn primary" size="small" v-preventReClick @click="submit">确认添加 </el-button>
                <span v-if="this.activeName=='first'">勾选金额：<span class="font">{{this.selectionTotalAmount}} </span></span>
                <span v-if="this.activeName=='first'">勾选数量：<span class="font">{{this.selectionTotalNumber}} </span></span>
              </el-col>
            </el-row>

            <div style="height:520px;margin-top:10px">
              <el-table ref="leftTable" v-loading="loading" :row-key="rowKey" border :data="leftTableData" v-show="this.activeName=='first'" height="500" style="width: auto; margin: 0 10px" @selection-change="handleChildSelectionChange"  :header-cell-style="{ background: '#DDEBFF' }">
                <el-table-column type="selection" fixed :reserve-selection="true" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <template v-for="(item) in columOptions">
                  <el-table-column v-if="item.type=='date'" show-overflow-tooltip :prop="item.key" :min-width="item.width || 100" :label="item.label" :key="item.label">
                    <template slot-scope="scope">
                      {{scope.row[item.key] ? parseTime(new Date(scope.row[item.key]), "{y}-{m}-{d}") : ''}}
                    </template>
                  </el-table-column>
                  <el-table-column v-else-if="item.type=='datetime'" show-overflow-tooltip :min-width="item.width || 100" :prop="item.key" :label="item.label" :key="item.label">
                    <template slot-scope="scope">
                      {{scope.row[item.key] ? parseTime(new Date(scope.row[item.key])) : ''}}
                    </template>
                  </el-table-column>
                  <el-table-column v-else-if="item.type=='input'" show-overflow-tooltip :min-width="item.width || 100" :prop="item.key" :label="item.label" :key="item.label">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row[item.key]" @change="numberChange(scope.row)"></el-input>
                    </template>
                  </el-table-column>
                  
                  <el-table-column v-else show-overflow-tooltip :prop="item.key" :min-width="item.width || 100" :label="item.label" :key="item.label">
                    <template slot-scope="scope">
                      <span v-html=" item.fomtter ? item.fomtter(scope.row) : scope.row[item.key] "></span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
            <div class="dialog-tab-footer">
              <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[100,300, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
              </el-pagination>
            </div>

          </el-tab-pane>
          <el-tab-pane label="已选择单据" name="second">
            <el-row style="margin-top:6px;">
              <template v-for="(item, index) in rightFilterOptions">
                <el-col v-if="!item.hidden" :key="index" :span="item.type == 'date' ? 6 : 4">
                  <el-form-item :prop="item.code">
                    <el-date-picker v-if="item.type == 'date'" :clearable="false" v-model="rightQuery[item.code]" style="width:100%" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @input="val => dateRightChange(val, item)" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>

                    <el-input v-if="item.type == 'input'" v-model="rightQuery[item.code]" style="width:100%" :placeholder="'请填写' + item.name" @keydown.enter.native="rightQueryChange"></el-input>

                    <el-select v-if="item.type == 'select' && !item.multiple" v-model="rightQuery[item.code + 'Name']" style="width:100%" :placeholder="'请选择' + item.name" clearable filterable :filter-method="
                  (k) => selectFilterChange(item.filterMethod ? item.filterMethod : null, k, item)" @change="val => selectRightChange(val, item)">
                      <el-option v-for="m in item.data" :key="m.id" :label="item.labelName ? m[item.labelName] : m.name" :value="m.id"></el-option>
                    </el-select>

                    <el-select v-if="item.type == 'select' && item.multiple" v-model="rightQuery[item.code]" style="width:100%" :multiple="item.multiple" :placeholder="'请选择' + item.name" clearable filterable :filter-method="
                  (k) => selectFilterChange(item.filterMethod ? item.filterMethod : null, k, item)" @change="val => selectMultipleChange(val, item)">
                      <el-option v-for="m in item.data" :key="m.id" :label="item.labelName ? m[item.labelName] : m.name" :value="m.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </template>
              <el-col :span="12">
                <el-button class="btn primary" size="small" v-preventReClick @click="rightQueryChange">查询</el-button>
                <el-button class="btn default" size="small" v-preventReClick @click="resetRight">重置</el-button>
                <el-button size="small" style=" background:red; color: beige" v-if="this.activeName!='first'" v-preventReClick @click="remove">删除已选</el-button>
                <el-button class="btn primary" size="small" v-preventReClick @click="rightSubmit">确认添加 </el-button>
                <!-- <span v-if="this.activeName=='first'">勾选金额：<span class="font">{{this.selectionTotalAmount}} </span></span>
                <span v-if="this.activeName=='first'">勾选数量：<span class="font">{{this.selectionTotalNumber}} </span></span> -->
              </el-col>
            </el-row>

            <div style="height:520px;margin-top:10px">
              <el-table ref="rightTable" :row-key="rowKey" border :data="rightTableData" v-show="this.activeName!='first'" height="500" style="width: auto; margin: 0 10px" @selection-change="handleChildInSelectionChange"  :header-cell-style="{ background: '#DDEBFF' }">
                <el-table-column type="selection" fixed :reserve-selection="true" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <template v-for="(item) in columOptions">
                  <el-table-column v-if="item.type=='date'" show-overflow-tooltip :prop="item.key" :min-width="item.width || 100" :label="item.label" :key="item.label">
                    <template slot-scope="scope">
                      {{scope.row[item.key] ? parseTime(new Date(scope.row[item.key]), "{y}-{m}-{d}") : ''}}
                    </template>
                  </el-table-column>
                  <el-table-column v-else-if="item.type=='datetime'" show-overflow-tooltip :min-width="item.width || 100" :prop="item.key" :label="item.label" :key="item.label">
                    <template slot-scope="scope">
                      {{scope.row[item.key] ? parseTime(new Date(scope.row[item.key])) : ''}}
                    </template>
                  </el-table-column>
                  <el-table-column v-else show-overflow-tooltip :prop="item.key" :min-width="item.width || 100" :label="item.label" :key="item.label">
                    <template slot-scope="scope">
                      <span v-html=" item.fomtter ? item.fomtter(scope.row) : scope.row[item.key] "></span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
            <div class="dialog-tab-footer">
              <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[100,300, 500, 1000]" :page-size="rightQuery.pageSize" @size-change="rightHandleSizeChange" :current-page="rightQuery.pageIndex" :total="rightTotal" @current-change="rightChangePage">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>

      </template>

    </el-form>
  </el-dialog>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin";
import { parseTime, DateAdd, addMonthF } from "@/utils/dataFormat";
import { Debounce } from "@/utils/utils";

export default {
  components: {},
  name: "selectDialogByWholeOrder",
  mixins: [GetDataMixin],
  data () {
    return {
      activeName: 'first',
      open: false,
      leftTableData: [], //左边表格数据
      // keyWord: '',
      defaultProps: {
        children: "children",
        label: "name",
      },
      query: {
        pageIndex: 1,
        pageSize: 100,
      },
      rightQuery: {
        pageIndex: 1,
        pageSize: 100,
      },
      // list: [],
      total: 0,

      childLeftIds: [],
      childLeftMultipleSelection: [],
      childLeftMultiple: true,
      loading: false,

      rightTotal: 0,
      rightTableSummaryData: [],// 最终右边总数据
      rightTableData: [], // 右边查询条件后的数据
      rightTableTotalData: [], // 右边查询条件分页后的数据
      selectionTotalNumber: 0,//勾选数量
      selectionTotalAmount: 0,//勾选金额
      selectedTotalNumber: 0,//已选数量
      selectedTotalAmount: 0,//已选金额
      childRightIds: [], //已选ids
      childRightSelection: [],//已选
      rightFilterOptions: [
        {
          name: "入库/退货单号",
          type: "input",
          code: "purchaseInStockNo",
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "是否红冲",
          type: "input",
          code: "isRed",
          hidden: true,
          defaultValue: 0
        },
        {
          name: "业务类型",
          type: 'select',
          code: 'categorys',
          multiple: true,
          hidden: true,
          defaultValue: [0, 1, 2]
        }
      ],
      selectedIsLeft: -1,
      canItBeselected:false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default () {
        return false;
      },
    },
    dialogTitle: {
      type: String,
      default () {
        return '';
      },
    },
    filterOptions: {
      type: Array,
      default () {
        return []
      }
    },
    columOptions: {
      type: Array,
      default () {
        return []
      }
    },
    getDataFunction: {
      type: Function,
      default () {
        return () => { }
      }
    },
    pageAuto: {
      type: Boolean,
      default () {
        return true;
      },
    },
    rowKey: {
      type: String,
      default () {
        return 'inStockDetailId'
      }
    },

    returnInvoiceAmount:
    {
      type: Number,
      default () {
        return 0
      }
    },
    returnInvoiceCode: {
      type: String,
      default () {
        return ''
      }
    },

  },
  created () {

  },
  mounted () {
    this.resetQuery();
    this.resetRightQuery();
    // this.getData()


  },
  watch: {
    show (val, oldVal) {
      this.open = val;
      if (this.open) {
        window.addEventListener('keydown',this.keydown )
        this.$nextTick(()=>{
          this.$refs.purchaseInStockNo[0].focus()
        })
        if (this.rightTableData.length <= 0) {
          // if (this.$refs.leftTable) {
          //   this.$refs.leftTable.clearSelection()
          // }
          this.childLeftIds = []
          this.childLeftMultipleSelection = []
          this.childLeftMultiple = false
        }
        else {

        }
        this.activeName = 'first'
      }
    },

  },


  methods: {
    keydown(e){
      if(e.key=='Enter'){
        if(this.canItBeselected){
          this.$refs.leftTable.toggleRowSelection(this.leftTableData[this.selectedIsLeft])
        }
      }
      if(e.key == 'Escape'){
        this.canItBeselected= false
        this.selectedIsLeft = -1
        this.$nextTick(()=>{
          this.$refs.purchaseInStockNo[0].focus()
        })
      }
      if(e.key === 'ArrowUp' || e.key === 'ArrowDown'){
        e.preventDefault(); // 阻止默认滚动行为
        this.canItBeselected= true
        const table = this.$refs.leftTable;
        
        const tableData = this.leftTableData || table.data 
        this.$nextTick(()=>{
          
          this.$refs.purchaseInStockNo[0].blur()
        })
        if (tableData.length === 0) return; // 无数据时直接返回
            let  setTableBackgroundColor = ()=>{
              // 获取表格体DOM
              const tableBody = table.$el.querySelector('.el-table__body-wrapper tbody');
              if (!tableBody) return;
              // 清除所有行背景色
              const allRows = tableBody.querySelectorAll('.el-table__row');
              allRows.forEach(row => row.style.backgroundColor = '');
              // 设置当前行背景色（示例颜色可调整）
              const currentRow = allRows[this.selectedIsLeft];
              if (currentRow) {
                currentRow.style.backgroundColor = '#ebf4ff';
              }

              const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
                  if (!bodyWrapper) return;

                  // 获取所有行元素
                  const rows = bodyWrapper.querySelectorAll('.el-table__row');
                  if (rows.length <= this.selectedIsLeft) return;

                  // 计算目标行的位置并滚动
                  const targetRow = rows[this.selectedIsLeft];
                  bodyWrapper.scrollTop = targetRow.offsetTop - bodyWrapper.offsetTop;
            }
        // 调整索引逻辑
        if (e.key === 'ArrowDown') {
          this.selectedIsLeft++
          if(this.selectedIsLeft > tableData.length ){
            this.selectedIsLeft = tableData.length
          }
        } else if (e.key === 'ArrowUp') {
          if( this.selectedIsLeft>0){
            this.selectedIsLeft--
          }else{
            this.selectedIsLeft = 0
          }
        }
        setTableBackgroundColor()
      }
    },
    selectFilterChange: Debounce(function (f, keyWord, o) {
      if (f) {
        f(keyWord).then((res) => {
          o.data = res;
        });
      }
    }, 500),
    cancel () {
      this.open = false;
      window.removeEventListener('keydown',this.keydown )
      this.selectedIsLeft = -1
      this.$emit("close");
      
      // this.$emit("returnData", this.rightTableData);
      this.$refs.leftTable.clearSelection();
    },
    rightSubmit () {
      this.open = false;
      this.$emit("returnData", this.rightTableSummaryData);
    },
    clear () {
      this.rightTableData = []
      this.rightTableTotalData = []
      this.rightTableSummaryData = []
      this.childRightIds = []
      this.childRightSelection = []
      if (this.$refs.rightTable) {
        this.$refs.rightTable.clearSelection();
      }

      this.selectedTotalAmount = 0
      this.selectedTotalNumber = 0
      this.selectionTotalAmount = 0;
      this.selectedTotalNumber = 0;

      this.leftTableData = []
      this.childLeftMultipleSelection = []
      this.childLeftIds = []
      if (this.$refs.leftTable) {

        this.$refs.leftTable.clearSelection();
      }

    },
    submit () {

      // 传入左边选中的数据
      let leftSelectdData = this.childLeftMultipleSelection;

      this.updateThisUnRegisterNumber(leftSelectdData)
      this.changeSelectedInfo(this.rightTableSummaryData);
      this.getRightData()

      this.activeName = 'second'
    },
    getData () {
      this.loading = true
      this.getDataFunction(this.query)
        .then(res => {
          this.total = res.returnData.totalCount;
          res.returnData.data.map(e => {
            e.thisUnRegisterNumber = e.unRegisterNumber  //本次匹配数量
            e.thisAmount = e.unRegisterAmount // 本次匹配金额
          })

          this.leftTableData = res.returnData.data;
          this.updateLeftDataByRightData()
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 根据左边改右边
    updateThisUnRegisterNumber (list) {
      if (list) {
        list.map(e => {

          if (this.childLeftMultipleSelection) {
            let leftSelected = this.childLeftMultipleSelection.find(x => x.inStockDetailId == e.inStockDetailId)
            if (leftSelected) {
              // if (e.thisUnRegisterNumber != 0) {
              //   // console.log(e.thisUnRegisterNumber, 'thisUnRegisterNumber', e.unRegisterNumber, 'e.unRegisterNumber')
              //   let child = this.rightTableSummaryData.find(x => x.inStockDetailId == e.inStockDetailId)
              //   if (child) {
              //     child.thisUnRegisterNumber = e.thisUnRegisterNumber
              //     child.amount = e.amount
              //   }
              //   else {
              //     let o = JSON.parse(JSON.stringify(e))
              //     this.rightTableSummaryData.push(o)
              //   }

              //   console.log(e.thisUnRegisterNumber, e.unRegisterNumber, e.inStockNumber, "ddddd");
              //   e.thisUnRegisterNumber = e.unRegisterNumber
              //   e.unRegisterNumber = e.inStockNumber - e.thisUnRegisterNumber
              //   e.amount = e.thisUnRegisterNumber * e.inStockPrice
              // }
              if (e.thisUnRegisterNumber != 0) {
                let child = this.rightTableSummaryData.find(x => x.inStockDetailId == e.inStockDetailId)
                if (child) {
                  child.thisUnRegisterNumber = e.thisUnRegisterNumber
                  child.thisAmount = (e.thisUnRegisterNumber * e.inStockPrice).toFixed(3) * 1
                }
                else {
                  let o = JSON.parse(JSON.stringify(e))
                  this.rightTableSummaryData.push(o)
                }

                e.thisUnRegisterNumber = e.unRegisterNumber - e.thisUnRegisterNumber
                e.thisAmount = (e.thisUnRegisterNumber * e.inStockPrice).toFixed(3) * 1

                let leftTableData = this.leftTableData.find(x => x.inStockDetailId == e.inStockDetailId)
                if (leftTableData) {
                  leftTableData.thisUnRegisterNumber = e.thisUnRegisterNumber
                  leftTableData.thisAmount = e.thisAmount
                }
              }

            }
          }
          return e
        })
      }
    },
    // 根据右边改左边
    updateLeftDataByRightData () {
      if (this.rightTableSummaryData) {
        this.rightTableSummaryData.forEach(item => {

          let leftDetail = this.leftTableData.find(x => x.inStockDetailId == item.inStockDetailId)
          if (leftDetail) {
            leftDetail.thisUnRegisterNumber = leftDetail.unRegisterNumber - item.thisUnRegisterNumber
            leftDetail.thisAmount = (leftDetail.thisUnRegisterNumber * leftDetail.inStockPrice).toFixed(3) * 1
          }

        })
      }
    },


    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    rightChangePage (val) {
      this.$set(this.rightQuery, "pageIndex", val);
      this.getRightData();
    },
    rightHandleSizeChange (val) {
      this.$set(this.rightQuery, "pageSize", val);
      this.getRightData();
    },
    handleClick (tab, event) {
      console.log(event, "event")
      if (tab.name == "second") {
        // console.log(this.$refs.rightTable, "this.$refs.rightTable");
        if (this.$refs.rightTable) {
          this.$refs.rightTable.clearSelection()
          this.childRightSelection = [];
          this.childRightIds = [];
        }
      } else {

      }
    },
    numberChange (row, index) {
      row.thisAmount = (row.thisUnRegisterNumber * row.inStockPrice).toFixed(3) * 1;
      if (this.childLeftMultipleSelection.length > 0) {

        let amount = 0;
        let leftSelected = this.childLeftMultipleSelection.find(x => x.inStockDetailId == row.inStockDetailId);
        if (leftSelected) {
          amount += row.thisAmount;
          leftSelected.thisUnRegisterNumber = row.thisUnRegisterNumber;
          leftSelected.thisAmount = row.thisAmount;
        } else {
          amount += item.thisAmount;
        }

        this.selectionTotalAmount = amount.toFixed(3) * 1;
      }
    },
    // 重置
    reset () {
      // this.query = {
      //   pageSize: 20,
      //   pageIndex: 1,
      // };
      this.resetQuery()
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 100);

      this.getData();
    },
    resetRight () {

      this.resetRightQuery()
      this.rightQuery.rightInStockNo = ""
      this.rightQuery.rightDistributionNo = ""
      this.rightQuery.rightBatch = ""
      this.rightQuery.rightProductName = ""
      this.$set(this.rightQuery, "rightDate", []);
      this.rightQuery.startDate = ""
      this.rightQuery.endDate = ""
      this.$set(this.rightQuery, "pageIndex", 1);
      this.$set(this.rightQuery, "pageSize", 100);

      this.getRightData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    rightQueryChange () {
      this.$set(this.rightQuery, "pageIndex", 1);

      this.getRightData();
    },
    getRightData () {
      var startDate = new Date(parseTime(new Date(this.rightQuery.startDate), "{y}-{m}-{d} 00:00:00"));
      var endDate = new Date(parseTime(new Date(this.rightQuery.endDate), "{y}-{m}-{d} 00:00:00"));
      // console.log(startDate, endDate, "endDate");
      this.rightTableTotalData = this.rightTableSummaryData.filter(e => {
        return (!Boolean(this.rightQuery.purchaseInStockNo) || e.purchaseInStockNo.includes(this.rightQuery.purchaseInStockNo)) //    rightInStockNoStr
          // && (!Boolean(this.rightQuery.rightDistributionNo) || e.drmDistributionNo.includes(this.rightQuery.rightDistributionNo))
          // && (!Boolean(this.rightQuery.rightBatch) || (e.batch && e.batch.includes(this.rightQuery.rightBatch)))
          // && (!Boolean(this.rightQuery.rightProductName) || e.productName.includes(this.rightQuery.rightProductName))
          && (!Boolean(this.rightQuery.startDate) || (new Date(parseTime(new Date(e.purchaseInStockDate), "{y}-{m}-{d} 00:00:00")) >= startDate && new Date(parseTime(new Date(e.purchaseInStockDate), "{y}-{m}-{d} 00:00:00")) <= endDate))

      });
      this.rightTotal = this.rightTableTotalData ? this.rightTableTotalData.length : 0
      this.rightTableData = this.getPaginationData(this.rightTableTotalData, this.rightQuery.pageIndex, this.rightQuery.pageSize)
    },
    getPaginationData (list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize)
    },

    //待选列表 --选择数据
    handleChildSelectionChange (selection) {

      this.childLeftMultipleSelection = selection;
      this.childLeftIds = selection.map((item) => item.inStockDetailId);
      this.childLeftMultiple = !selection.length;
      this.selectionTotalNumber = this.childLeftMultipleSelection.length;
      let amount = 0;
      this.childLeftMultipleSelection.filter((item) => {
        amount += item.amount
      })
      this.selectionTotalAmount = amount.toFixed(3) * 1;
    },
    rightChildSelectionDataReset (selection) {
      this.handleChildSelectionChange(selection)
      // 给左边选中的数据重新赋值
      let leftTableSummaryDataTemp = JSON.parse(JSON.stringify(selection));
      let newLeftData = [];
      leftTableSummaryDataTemp.forEach(item => {
        item.thisUnRegisterNumber = item.unRegisterNumber
        item.unRegisterNumber = item.number + item.unRegisterNumber
        item.thisAmount = (item.thisUnRegisterNumber * item.inStockPrice).toFixed(3) * 1
        item.price = item.inStockPrice
        let o = JSON.parse(JSON.stringify(item))
        newLeftData.push(o)
      })
      this.leftTableData = newLeftData;
      // 编辑时 已选的列表还在不在待选返回的列表里，不在则去掉选中
      this.leftTableData.forEach(e => {
        if (this.$refs.leftTable) {
          this.$refs.leftTable.toggleRowSelection(e, true)
        }
      })

      this.updateThisUnRegisterNumber(this.leftTableData);

      var rightTableSummaryDataTemp = JSON.parse(JSON.stringify(selection));
      let newRightData = [];
      // 处理接收已选中的数据
      rightTableSummaryDataTemp.forEach(item => {
        item.unRegisterNumber = item.number + item.unRegisterNumber
        item.thisUnRegisterNumber = item.number
        item.thisAmount = (item.thisUnRegisterNumber * item.inStockPrice).toFixed(3) * 1
        item.price = item.inStockPrice
        let o = JSON.parse(JSON.stringify(item))
        newRightData.push(o)
      })
      this.rightTableSummaryData = newRightData;

      this.changeSelectedInfo(this.rightTableSummaryData);
      this.getRightData()
    },

    // 已选列表 --选择数据
    handleChildInSelectionChange (selection) {
      this.childRightSelection = selection;
      this.childRightIds = selection.map((item) => item.inStockDetailId);
    },

    resetQuery () {
      // console.log('resetquery', this.options, this.query)
      if (this.filterOptions) {
        // console.log(this.filterOptions)
        this.filterOptions.forEach((o) => {
          if (o.type == "select") {
            if (o.filterMethod) {
              o.filterMethod("").then((res) => {
                o.data = res;
              });
            }

            let value = ''
            if (o.defaultValue || o.defaultValue == 0) {
              value = o.defaultValue
            }
            this.$set(this.query, o.code, value);
            this.$set(this.query, o.code + 'Name', value);
          }
          else if (o.type == "date") {
            if (!o.startDateCode && !o.endDateCode) {
              o.startDateCode = "startDate"
              o.endDateCode = "endDate"
            }
            if (!this.query[o.startDateCode]) {
              this.$set(this.query, o.startDateCode, '');
            }
            if (!this.query[o.startDateCode]) {
              this.$set(this.query, o.endDateCode, '');
            }
            if (o.defaultValue) {
              this.$set(this.query, o.code, o.defaultValue);
              this.$set(this.query, o.startDateCode, o.defaultValue[0]);
              this.$set(this.query, o.endDateCode, o.defaultValue[1]);
            } else {
              this.$set(this.query, o.code, []);
              this.$set(this.query, o.startDateCode, '');
              this.$set(this.query, o.endDateCode, '');
            }
          }
          else if (o.type == "input") {
            let value = ''
            if (o.defaultValue || o.defaultValue == 0) {
              value = o.defaultValue
            }

            this.$set(this.query, o.code, value);
          }

          if (o.type == "checkbox") {
            this.$set(this.query, o.code, []);
          }
        });
      }
    },
    resetRightQuery () {
      // console.log('resetquery', this.options, this.query)
      if (this.rightFilterOptions) {
        console.log(this.rightFilterOptions)
        this.rightFilterOptions.forEach((o) => {
          if (o.type == "select") {
            if (o.filterMethod) {
              o.filterMethod("").then((res) => {
                o.data = res;
              });
            }

            let value = ''
            if (o.defaultValue || o.defaultValue == 0) {
              value = o.defaultValue
            }
            this.$set(this.rightQuery, o.code, value);
            this.$set(this.rightQuery, o.code + 'Name', value);
          }
          else if (o.type == "date") {
            if (!o.startDateCode && !o.endDateCode) {
              o.startDateCode = "startDate"
              o.endDateCode = "endDate"
            }
            if (!this.rightQuery[o.startDateCode]) {
              this.$set(this.rightQuery, o.startDateCode, '');
            }
            if (!this.rightQuery[o.startDateCode]) {
              this.$set(this.rightQuery, o.endDateCode, '');
            }
            if (o.defaultValue) {
              this.$set(this.rightQuery, o.code, o.defaultValue);
              // this.$set(this.rightQuery, o.startDateCode, o.defaultValue[0]);
              // this.$set(this.rightQuery, o.endDateCode, o.defaultValue[1]);
            } else {
              this.$set(this.rightQuery, o.code, []);
              this.$set(this.rightQuery, o.startDateCode, '');
              this.$set(this.rightQuery, o.endDateCode, '');
            }
          }
          else if (o.type == "input") {
            let value = ''
            if (o.defaultValue || o.defaultValue == 0) {
              value = o.defaultValue
            }

            this.$set(this.rightQuery, o.code, value);
          }

          if (o.type == "checkbox") {
            this.$set(this.rightQuery, o.code, []);
          }
        });
      }
    },
    dateChange (val, item) {
      this.$nextTick(() => {
        let startDateCode = 'startDate'
        let endDateCode = 'endDate'
        if (item.startDateCode && item.endDateCode) {
          startDateCode = item.startDateCode
          endDateCode = item.endDateCode
        }

        // if (item.code == "date") {
        if (val == null) {
          this.query[startDateCode] = "";
          this.query[endDateCode] = "";
        } else {
          this.query[startDateCode] = val[0];
          this.query[endDateCode] = val[1];
        }
      });
    },
    dateRightChange (val, item) {
      this.$nextTick(() => {
        let startDateCode = 'startDate'
        let endDateCode = 'endDate'
        if (item.startDateCode && item.endDateCode) {
          startDateCode = item.startDateCode
          endDateCode = item.endDateCode
        }

        // if (item.code == "date") {
        if (val == null) {
          this.rightQuery[startDateCode] = "";
          this.rightQuery[endDateCode] = "";
        } else {
          this.rightQuery[startDateCode] = val[0];
          this.rightQuery[endDateCode] = val[1];
        }
      });
    },
    selectChange (val, o) {
      // 单选
      this.$set(this.query, o.code, val);
      let m = o.data.find(e => e.id == val)
      console.log(m);
      
      // this.query[o.code + 'Name'] = m.name
      if (val !== '') {
        this.$set(this.query, o.code + 'Name', m.name);
      }
      else {
        this.$set(this.query, o.code + 'Name', '');
      }
    },
    selectRightChange (val, o) {

      this.$set(this.rightQuery, o.code, val);
      let m = o.data.find(e => e.inStockDetailId == val)
      // this.query[o.code + 'Name'] = m.name
      if (val !== '') {
        this.$set(this.rightQuery, o.code + 'Name', m.name);
      }
      else {
        this.$set(this.rightQuery, o.code + 'Name', '');
      }
    },
    selectMultipleChange (val, o) {
      // 多选
      this.query[o.code] = val
      let l = o.data.filter(e => val.indexOf(e.inStockDetailId) != -1)
      this.query[o.code + 'Name'] = l.map(e => e.name)
    },

    remove () {
      //删除已选列表数据，
      if (this.childRightSelection.length > 0) {
        // 选中的数据

        this.rightTableData = this.rightTableData.filter(
          (i) => !this.childRightIds.includes(i.inStockDetailId)
        );
        this.rightTableSummaryData = this.rightTableSummaryData.filter(
          (i) => !this.childRightIds.includes(i.inStockDetailId)
        );
        this.rightTableTotalData = this.rightTableTotalData.filter(
          (i) => !this.childRightIds.includes(i.inStockDetailId)
        );

        // 已删除之后待选的✔也去掉
        let rightIds = this.rightTableTotalData.map((item) => item.inStockDetailId);

        this.$refs.leftTable.clearSelection();
        this.leftTableData.forEach(e => {
          if (rightIds.includes(e.inStockDetailId)) {
            if (this.$refs.leftTable) {
              this.$refs.leftTable.toggleRowSelection(e, true);
            }
          }
        })
        // 重置已选金额
        this.changeSelectedInfo(this.rightTableSummaryData);
        // 重置待选列表数据（数量）
        this.updateLeftDataByRightData();
        this.childRightSelection.forEach((item => {
          let l = this.leftTableData.find(e => e.inStockDetailId == item.inStockDetailId)
          if (l) {
            l.thisUnRegisterNumber += item.thisUnRegisterNumber
            l.thisAmount = (l.thisUnRegisterNumber * l.inStockPrice).toFixed(3) * 1
          }
        }))
      }
    },
    changeSelectedInfo (list) {
      if (list != null) {
        // 获取已选金额和已选数量
        let totalNumber = 0;
        let totalAmount = 0;
        for (let i = 0; i < list.length; i++) {
          totalNumber += list[i].thisUnRegisterNumber * 1;
          totalAmount += list[i].amount;
        }
        this.selectedTotalAmount = totalAmount.toFixed(3) * 1;
        this.selectedTotalNumber = totalNumber;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table {
  overflow: visible !important;
}
.font {
  color: red;
  margin: 0px 5px;
}
.dialog-tab-footer {
  text-align: right;
  margin: 20px 0;
  // margin-left: 20px;
}
</style>
